/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import {
    IPasswordResetVerificationItem,
    IPasswordResetVerificationLoading,
    IPasswordResetVerificationLocalAccount,
    IPasswordResetVerificationViewProps
} from '@msdyn365-commerce-modules/account-management/src/modules/password-reset-verification/password-reset-verification';

import {
    IPasswordResetVerificationConfig,
    IPasswordResetVerificationProps
} from '@msdyn365-commerce-modules/account-management/src/modules/password-reset-verification/password-reset-verification.props.autogenerated';

const PasswordResetVerificationItem: React.FC<IPasswordResetVerificationItem> = ({ wrapper, label, errorMessage, input }) => {
    return (
        <Node {...wrapper}>
            {label}
            {errorMessage}
            {input}
        </Node>
    );
};

const PasswordResetVerificationLoading: React.FC<IPasswordResetVerificationLoading> = ({ modal, modalBody, icon, message }) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};
/**
 *
 * Password Reset Verification Component
 * @extends {React.PureComponent<IPasswordResetVerificationViewProps & IPasswordResetVerificationProps<IPasswordResetVerificationConfig>>}
 */

export class PasswordResetVerificationView extends React.PureComponent<
    IPasswordResetVerificationViewProps & IPasswordResetVerificationProps<IPasswordResetVerificationConfig>
> {
    constructor(props: IPasswordResetVerificationViewProps & IPasswordResetVerificationProps<IPasswordResetVerificationConfig>) {
        super(props);
    }
    public componentDidMount(): void {
        // document.body && document.body.addEventListener('keyup', this.onChangeEmailInput);
        const emailInputField = document.getElementById('email');
        const sendVerificationCodeBtn = document.getElementById('email_ver_but_send');
        emailInputField &&
            emailInputField.addEventListener('keyup', (event: KeyboardEvent) => {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    sendVerificationCodeBtn && sendVerificationCodeBtn.click();
                }
            });
    }
    public render(): JSX.Element {
        const {
            passwordResetVerification,
            viewState,
            loading,
            defaultAADConainer,
            aadConainer,
            heading,
            passwordResetVerificationLocalAccount
        } = this.props;

        return (
            <Module {...passwordResetVerification}>
                {viewState.isShowLoading && <Node {...defaultAADConainer} />}
                {viewState.isShowLoading && <PasswordResetVerificationLoading {...loading} />}
                <Node {...aadConainer}>
                    {heading}
                    {this.LocalAccount(passwordResetVerificationLocalAccount)}
                </Node>
            </Module>
        );
    }

    public LocalAccount: React.FC<IPasswordResetVerificationLocalAccount> = ({
        localAccount,
        items,
        successMessage,
        errorMessage,
        verificationButtonsWrapper,
        verificationButtons,
        buttonsWrapper,
        buttons,
        verificationSuccessModal,
        verificationSuccessModalMessage
    }) => {
        return (
            <Node {...localAccount}>
                {items &&
                    items.map((item: IPasswordResetVerificationItem) => {
                        return (
                            // @ts-ignore
                            <PasswordResetVerificationItem key={item.key} {...item} />
                        );
                    })}
                {successMessage &&
                    successMessage.map((message: React.ReactNode, index: number) => {
                        return <React.Fragment key={index}>{message}</React.Fragment>;
                    })}
                {errorMessage &&
                    errorMessage.map((error: React.ReactNode, index: number) => {
                        return <React.Fragment key={index}>{error}</React.Fragment>;
                    })}
                <Node {...verificationButtonsWrapper}>
                    {verificationButtons &&
                        verificationButtons.map((button: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{button}</React.Fragment>;
                        })}
                </Node>
                <Node {...buttonsWrapper}>
                    {buttons &&
                        buttons.map((button: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{button}</React.Fragment>;
                        })}
                </Node>
                <Node {...verificationSuccessModal}>
                    <Node {...verificationSuccessModalMessage} />
                </Node>
            </Node>
        );
    };
}

export default PasswordResetVerificationView;
